import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

export interface IConfirmationPopUpPreset {
	title?: string;
	description?: string;
	buttonsData?: {text: string, onClick: Subject<any>}[];

	clone(): IConfirmationPopUpPreset;
}

@Injectable({
	providedIn: 'root'
})
export class ConfirmationPopUpService {


	private static readonly PRESETS: {[key: string]: IConfirmationPopUpPreset} = {
		DEFAULT: {
			title: "Are you sure?",
			description: "You cannot undo this action.",
			buttonsData: [
				{
					text: "Confirm",
					onClick: new Subject<any>()
				},
				{
					text: "Cancel",
					onClick: new Subject<any>()
				}
			],
			clone(): IConfirmationPopUpPreset {
				return <IConfirmationPopUpPreset>{
					title: ConfirmationPopUpService.PRESETS.DEFAULT.title,
					description: ConfirmationPopUpService.PRESETS.DEFAULT.description,
					buttonsData: [
						{
							text: ConfirmationPopUpService.PRESETS.DEFAULT.buttonsData[0].text,
							onClick: new Subject<any>()
						},
						{
							text: ConfirmationPopUpService.PRESETS.DEFAULT.buttonsData[1].text,
							onClick: new Subject<any>()
						}
					],
					clone(): IConfirmationPopUpPreset { return ConfirmationPopUpService.PRESETS.DEFAULT.clone(); }
				};
			}
		}
	};

	public getPreset(confirmationPopUpPresetType: ConfirmationPopUpService.ConfirmationPopUpPresetType): IConfirmationPopUpPreset {
		return ConfirmationPopUpService.PRESETS[ConfirmationPopUpService.ConfirmationPopUpPresetType[confirmationPopUpPresetType]].clone();
	}

	public visible: boolean = false;

	public title: string;
	public description: string;
	public buttonsData: {text: string, onClick: Subject<any>}[];

	public reset(): void {
		

		this.title = null;
		this.description = null;
		this.buttonsData = null;
	}

	public show(options: IConfirmationPopUpPreset): void {
		console.error("SHOW !!!");

		if (options.title) {
			this.title = options.title;
		}

		if (options.description) {
			this.description = options.description;
		}

		if (options.buttonsData) {
			this.buttonsData = options.buttonsData;
		}

		this.visible = true;
	}

	public hide(): void {
		this.visible = false;
	}

	constructor() { }
}

export namespace ConfirmationPopUpService {
	export enum ConfirmationPopUpPresetType {
		DEFAULT,
	}
}
